import { useEffect, useRef } from 'react';
import { launchProductUrlInNewTab } from '@/utils/productNewTabLaunch';

interface UseInitialProductNewTabLaunchOptions {
  enabled: boolean;
  iframeUrl: string;
  isReady: boolean;
}

export function useInitialProductNewTabLaunch({
  enabled,
  iframeUrl,
  isReady,
}: UseInitialProductNewTabLaunchOptions): void {
  const hasLaunchedRef = useRef(false);

  useEffect(() => {
    if (hasLaunchedRef.current || !enabled || !isReady || !iframeUrl) {
      return;
    }

    hasLaunchedRef.current = true;
    launchProductUrlInNewTab(iframeUrl);
  }, [enabled, iframeUrl, isReady]);
}
